import { render, staticRenderFns } from "./payConfirmRouter.vue?vue&type=template&id=0953db0f&scoped=true&"
import script from "./payConfirmRouter.vue?vue&type=script&lang=js&"
export * from "./payConfirmRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0953db0f",
  null
  
)

export default component.exports